import { Directive, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[studioEllipsisActive]',
})
export class EllipsisActiveDirective implements OnInit {
  @Output() ellipsisChanged = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {}

  ngOnInit() {
    const isActive = this.el.nativeElement.offsetHeight < this.el.nativeElement.scrollHeight;

    this.ellipsisChanged.emit(isActive);
  }
}
